import type { InjectionKey } from 'vue';

import type { Virtualizer } from '../components/Virtualizer';
import type { WorkerPoolManager } from '../worker';

// Provide/inject keys that wire the worker pool and virtualizer down to the
// diff components. They mirror the React adapter's `WorkerPoolContext` and
// `VirtualizerContext`; a missing provider resolves to `undefined`, which the
// components treat as "no shared pool / not virtualized".
export const WorkerPoolInjectionKey: InjectionKey<
  WorkerPoolManager | undefined
> = Symbol('pierre-diffs-worker-pool');

export const VirtualizerInjectionKey: InjectionKey<Virtualizer | undefined> =
  Symbol('pierre-diffs-virtualizer');
